export default __webpack_public_path__ + "static/media/img-yer-4-left-3.f7c5e718.png";